var exports = {
  "kL": "xcc377c0b--5ba00c--container",
  "cL": "xcc377c0b--5ba00c--builder",
  "M3": "xcc377c0b--5ba00c--contacts",
  "h2": "xcc377c0b--5ba00c--logo-link",
  "h_": "xcc377c0b--5ba00c--description",
  "xu": "xcc377c0b--5ba00c--name-link",
  "UU": "xcc377c0b--5ba00c--name",
  "Qs": "xcc377c0b--5ba00c--label--overlap",
  "WD": "xcc377c0b--5ba00c--labels",
  "Qi": "xcc377c0b--5ba00c--builder-name-section",
  "M1": "xcc377c0b--5ba00c--stats",
};

module.exports = exports;
